import React from 'react';
export function Footer() {
  return <footer className="bg-dark-900 py-12 px-4 border-t border-primary/20 text-center" data-id="element-96">
      <div className="max-w-4xl mx-auto" data-id="element-97">
        <h2 className="text-2xl font-bold text-primary mb-4" data-id="element-98">
          🌿 BIBLIOTECADIGITAL.ONLINE™
        </h2>
        <p className="text-cream/80 text-lg mb-2" data-id="element-99">
          El sistema de desconexión digital N°1 para familias argentinas.
        </p>
        <p className="text-cream/60 italic mb-8" data-id="element-100">
          Porque criar sin pantallas no debería costarte cada tarde de tu vida.
        </p>

        <div className="flex flex-col md:flex-row justify-center items-center gap-4 text-cream/70 text-sm mb-8" data-id="element-101">
          <span data-id="element-102">📧 soportebibliodigital@gmail.com</span>
          <span className="hidden md:inline" data-id="element-103">·</span>
          <span data-id="element-104">🌐 www.bibliotecadigital.online</span>
        </div>

        <p className="text-cream/40 text-xs mb-8" data-id="element-105">
          © BibliotecaDigital.online™ 2026 — Todos los derechos reservados.
          Prohibida la reproducción y redistribución sin autorización expresa.
        </p>

        <p className="text-xl font-serif italic text-[#FFF8F0]" data-id="element-106">
          🌿 "La próxima tarde puede ser diferente."
        </p>
      </div>
    </footer>;
}